export default {
  dateTimeCol: {
    width: 190,
  },
  createdByCol: {
    width: 180,
  },
  notesCol: {
    whiteSpace: 'normal',
  },
  actionCol: {
    width: 150,
  },
  noData: {
    fontSize: 200,
    color: 'lightgrey',
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    // fontSize: 24,
    fontStyle: 'italic',
  },
};



// WEBPACK FOOTER //
// ./src/components/NotesTable/styles.js